/* SLIDE 8 */

import React from "react";
import searchIcon from "assets/icons/searchIcon.svg";
import settingIcon from "assets/icons/settingIcon.svg";
import ButtonBot from "shared/components/ButtonBot";
const ParkingStatusAdditionalPage = () => {
  const parkingData = [
    {
      id: "01",
      vehicleNum: "11기1111",
      entryTime: "2024-10-10 13:57",
      note: "한메일주차구역",
      status: "요금확인",
    },
    {
      id: "02",
      vehicleNum: "11기1112",
      entryTime: "2024-10-10 13:57",
      note: "-",
      status: "요금확인",
    },
    {
      id: "03",
      vehicleNum: "11기1113",
      entryTime: "2024-10-10 13:57",
      note: "-",
      status: "요금확인",
    },
    {
      id: "04",
      vehicleNum: "-",
      entryTime: "-",
      note: "-",
      status: "입차하기",
    },
    {
      id: "05",
      vehicleNum: "-",
      entryTime: "-",
      note: "-",
      status: "입차하기",
    },
    {
      id: "06",
      vehicleNum: "-",
      entryTime: "-",
      note: "-",
      status: "입차하기",
    },
    {
      id: "07",
      vehicleNum: "-",
      entryTime: "-",
      note: "-",
      status: "입차하기",
    },
    {
      id: "08",
      vehicleNum: "-",
      entryTime: "-",
      note: "-",
      status: "입차하기",
    },
    {
      id: "09",
      vehicleNum: "11기1119",
      entryTime: "2024-10-10 13:57",
      note: "-",
      status: "요금납입",
    },
  ];

  return (
    <div className="parking-status-container">
      <div className="header-container">
        <div className="parking-info-detail">
          <span className="parking-location">
            <span className="parking-title">주차장명 : </span>
            <span className="parking-address">새마을시장(01-002)</span>
          </span>
          <button className="settings-button">
            <img src={settingIcon} alt="setting" />
          </button>
        </div>

        <div className="search-container">
          <div className="search-input-container">
            <div className="search-icon">
              <img src={searchIcon} alt="search" />
            </div>
            <input
              type="text"
              className="search-input"
              placeholder="차량번호 검색"
            />
          </div>
          <button className="search-button">검색</button>
        </div>
      </div>

      <div className="table-container">
        <table className="parking-table">
          <thead>
            <tr>
              <th>주차면</th>
              <th>차량번호</th>
              <th>입차일시</th>
              <th>별칭</th>
              <th>입차/출차</th>
            </tr>
          </thead>
          <tbody>
            {parkingData.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.vehicleNum}</td>
                <td className="flex flex-col">
                  <span>{item.entryTime.split(" ")[0]}</span>
                  <span>{item.entryTime.split(" ")[1]}</span>
                </td>
                <td>{item.note}</td>
                <td>
                  <button
                    className={`status-button ${
                      item.status === "요금확인" ? "fee-paid" : "entry"
                    }`}
                  >
                    {item.status}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <ButtonBot textYes="입차하기" />
    </div>
  );
};

export default ParkingStatusAdditionalPage;
